export interface Module {
  title: string
  body: string
  tagline: string
  /** Repère couleur du module */
  color: string
  /** Module mis en avant sur la page */
  featured?: boolean
}

export const modules: Module[] = [
  {
    title: 'MODULE 1 — FONDAMENTAUX DE LA NUTRITION VÉGÉTALE',
    body: 'Physiologie de la nutrition, éléments essentiels, mécanismes d’absorption, macronutriments et oligoéléments, mobilité des éléments dans la plante, interactions et fonctions, avec des tableaux de référence pour retrouver l’essentiel en un coup d’œil.',
    tagline: 'Comprendre la plante avant d’interpréter ses symptômes.',
    color: 'rgb(var(--color-module-1))',
  },
  {
    title: 'MODULE 2 — CARENCES NUTRITIONNELLES ET SYMPTÔMES VISUELS',
    body: 'Le cœur du système. L’atlas des déficiences, toxicités et déséquilibres : N, P, K, Ca, Mg, S, Fe, Mn, Zn, Cu, B, Mo… Fiches comparatives, symptômes classés par organe (feuilles âgées, jeunes feuilles, tiges, fruits, racines) et arbres de décision pour orienter le diagnostic.',
    tagline: 'Un symptôme indique une piste, jamais une conclusion d’office.',
    color: 'rgb(var(--color-module-2))',
    featured: true,
  },
  {
    title: 'MODULE 3 — SOL, pH, CEC ET DISPONIBILITÉ DES NUTRIMENTS',
    body: 'pH, CEC, salinité, matière organique, structure et disponibilité réelle des éléments : pourquoi un nutriment présent dans le sol peut rester inaccessible à la plante. Interactions et grilles d’interprétation, avec des valeurs indicatives selon le laboratoire et la culture.',
    tagline: 'Chercher la cause dans le sol, pas seulement dans la feuille.',
    color: 'rgb(var(--color-module-3))',
  },
  {
    title: 'MODULE 4 — DIAGNOSTIC VISUEL ET ANALYSES VÉGÉTALES',
    body: 'Inspection de la parcelle, prélèvements, analyses foliaires et leur lecture. Distinguer une carence d’une maladie, d’un ravageur ou d’un stress, avec fiches de terrain et protocoles d’observation pas à pas.',
    tagline: 'Observer, prélever et confirmer avant d’agir.',
    color: 'rgb(var(--color-module-4))',
  },
  {
    title: 'MODULE 5 — NUTRITION SPÉCIFIQUE PAR CULTURE',
    body: 'Céréales, vigne, maraîchage, arbres fruitiers et cultures sous serre : stades clés, besoins, symptômes typiques et stratégies, à adapter aux caractéristiques de chaque culture et de chaque parcelle.',
    tagline: 'Chaque culture a ses besoins et ses signaux.',
    color: 'rgb(var(--color-module-5))',
  },
  {
    title: 'MODULE 6 — PLAN D’ACTION, SUIVI ET PROTOCOLES DE TERRAIN',
    body: 'Procédures pas à pas, fiches imprimables, tableaux de suivi, checklists, modèles de rapport et validation des interventions : de l’observation à la décision documentée, toujours après confirmation du diagnostic.',
    tagline: 'Une décision argumentée, suivie et vérifiée.',
    color: 'rgb(var(--color-module-6))',
  },
]
